export default __webpack_public_path__ + "static/media/CNo.72-4.0b982626.jpg";